let sessionSwitchInProgress = false

export const setSessionSwitchInProgress = (value: boolean) => {
  sessionSwitchInProgress = value
}

export const isSessionSwitchInProgress = () => sessionSwitchInProgress
